export default __webpack_public_path__ + "static/PromptIconTwo-72239f21025dada07382c465f2bc434e.png";